module.exports = __webpack_public_path__ + "img/solutionBj.6b250cab.png";